import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getDealerSources } from '@/api'

export interface IDealerSource {
  id: string
  friendlyName?: string
  type: string
}

export const useSourcesStore = defineStore('sources', () => {
  const sources = ref<IDealerSource[]>([])
  const isLoading = ref(false)
  const lastFetched = ref<Date | null>(null)

  const setSources = (data: IDealerSource[]) => {
    sources.value = data
    lastFetched.value = new Date()
  }

  const fetchSources = async (endpoint: string, accountId: string) => {
    if (!endpoint || !accountId) {
      console.warn('Cannot fetch sources: missing endpoint or accountId')
      return
    }

    isLoading.value = true
    try {
      const data = await getDealerSources(endpoint, accountId)
      setSources(data)
    } catch (error) {
      console.error('Failed to fetch sources:', error)
    } finally {
      isLoading.value = false
    }
  }

  const clearSources = () => {
    sources.value = []
    lastFetched.value = null
  }

  return {
    sources,
    isLoading,
    lastFetched,
    setSources,
    fetchSources,
    clearSources,
  }
})
